/**
 * viewportに入ってきた時に「フワっ」と表示する
 */
class Fuwa {

  /**
   * Create a new Router
   */
  constructor() {
    // this.addStylesheet()
  }

  // Public functions
  // ============================
  init() {
    let boxes = document.querySelectorAll('[data-fuwa]')
    boxes = Array.prototype.slice.call(boxes, 0) // IE11対策

    const doWhenIntersect = function (entries) {
      entries = Array.prototype.slice.call(entries, 0) // IE11対策
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          $(entry.target).attr('data-fuwa', 'visible')
        }
      })
    }
    const observer = new IntersectionObserver(doWhenIntersect, {
      root: null,
      rootMargin: '0px',
      threshold: 0
    })
    boxes.forEach(function (box) {
      observer.observe(box)
    })
  }

  // private functions
  // ============================

  // stylesheetもここで生成する場合、この関数を呼び出す。
  // 予めcssにスタイルを定義できる場合は下記を記述
  /*
  .fuwa
    opacity: 0
    transform: translateY(50 px)
    transition - duration: 1 s &
    .visible
      opacity: 1
      transform: translateY(0)
      transition - duration: 1 s
  */
  addStylesheet() {
    const css = `
.fuwa {
opacity: 0;
-webkit-transform: translateY(50px);
-o-transform: translateY(50px);
transform: translateY(50px);
-webkit-transition-duration: 1s;
-o-transition-duration: 1s;
transition-duration: 1s;
}
.fuwa.visible {
opacity: 1;
-webkit-transform: translateY(0);
-o-transform: translateY(0);
transform: translateY(0);
-webkit-transition-duration: 1s;
-o-transition-duration: 1s;
transition-duration: 1s;
}
`
    const head = document.head || document.getElementsByTagName('head')[0]
    const style = document.createElement('style')
    head.appendChild(style)
    style.type = 'text/css'
    if (style.styleSheet) {
      // This is required for IE8 and below.
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }
  }
}

export default Fuwa
